import moment from "moment";

const updateCalendar = (state, action) => {
  if (state === undefined) {
    return {
      calendar: [],
      calendarLoading: true,
      selectedEvent: null,
      children: [],
      training: [],
      error: null,
      filter: {
        startDay: moment().startOf("month").format("YYYY-MM-DD"),
        endDay: moment().endOf("month").format("YYYY-MM-DD"),
        filial: null,
        group: null,
        trainer: null,
      },
    };
  }

  switch (action.type) {
    case "CALENDAR_SELECTED_EVENT":
      return {
        ...state.calendar,
        selectedEvent: action.payload,
        children: action.payload.training,
      };
    case "CHILDREN_TOGGLE":
      const itemIndex = state.calendar.children.findIndex(
        ({ child: { id } }) => id === action.payload
      );
      const item = state.calendar.children[itemIndex];

      const newItem = {
        ...item,
        state_training_children_id: !item.state_training_children_id,
      };

      return {
        ...state.calendar,
        children: [
          ...state.calendar.children.slice(0, itemIndex),
          newItem,
          ...state.calendar.children.slice(itemIndex + 1),
        ],
      };
    case "CALENDAR_REQUESTED":
      return {
        ...state.calendar,
        calendarLoading: true,
      };
    case "REQUEST_TRAINING":
      return {
        ...state.calendar,
        training: action.payload,
      };
    case "CALENDAR_LOADED":
      return {
        ...state.calendar,
        error: null,
        calendar: action.payload,
        calendarLoading: false,
      };
    case "SET_CALENDAR_FILTER":
      return {
        ...state.calendar,
        filter: action.payload,
      };
    default:
      return state.calendar;
  }
};

export default updateCalendar;
